export const QUOTE_DEPOSIT_ID = 125;
export const JOB_DEPOSIT_ID = 126;
export const INVOICE_DEPOSIT_ID = 127;
